<template>
  <div>
    <div class="p-1 bg-red-500 text-white text-center fd:text-xl fm:text-sm">
        <span class="animate-pulse">کاربر گرامی چنانچه در هرکجای سایت دیتا یا ایتمی برای شما نمایش داده نشد یک بار صفحه را رفرش نمایید.</span>
    </div>
    <div class="container-fluid">
      
      <div class="flex">
        <aside :class="['w-[23%] border-l border-[#15273b] min-h-screen bg-[#15273b] ', $store.state.toggleAside ? 'fm:block fm:fixed fm:w-[90%] fm:z-100' : 'fm:hidden']">
          <div class="flex flex-col gap-8 p-4">
            <div class="flex justify-between">
              <div class="flex items-center gap-2">
                <routerLink to="/dashboard">
                  <img :src="$store.state.url + $store.state.user.avatar" class="rounded-full w-[100px] h-[100px] fm:w-[60px] fm:h-[60px]"/>
                </routerLink>
                <div class="flex flex-col gap-2">
                  <span class="text-gray-300 !font-medium fm:text-sm">{{$store.state.user.name}}</span>
                  <span class="text-gray-300 !font-medium fm:text-sm">وضعیت دسترسی:
                    <b class="text-green-500" v-if="$store.state.user.status === 'yes'">فعال</b>
                    <b class="text-red-500" v-else>غیر فعال</b>
                  </span>
                  <span class="text-gray-300 !font-medium fm:text-sm" v-if="isEventManager">موجودی کیف پول:
                    <b class="text-green-500">{{ walletAmount }} ریال</b>
                  </span>
                </div>
              </div>
              <div class="fd:hidden">
                <span class="cursor-pointer" @click="$store.state.toggleAside = false"><font-awesome-icon icon="fa-solid fa-times" class="icon text-lg text-white"/></span>
              </div>
            </div>
          </div>
          <div class="border-b border-[#15273b] w-full py-3"></div>
          <div class="">
            <ul>
              <li :class="['text-gray-300 p-2']">
                <div class="flex items-center justify-between">
                  <routerLink to="/" class="flex items-center gap-1">
                    <span class="text-gray-300"></span>
                    <span class="text-gray-300">خانه</span>
                  </routerLink>
                </div>
              </li>
              <li :class="['text-gray-300 p-2']">
                <div class="flex items-center justify-between">
                  <routerLink :to="{name:'Dashboard'}" class="flex items-center gap-1">
                    <span class="text-gray-300"></span>
                    <span class="text-gray-300">داشبورد</span>
                  </routerLink>
                </div>
              </li>
            </ul>
            <ul class="flex flex-col" v-if="store.state.userPermissions.length > 0 && $store.state.user.access === 'admin'">
              <DashboardAside
                  v-if="hasPermission(['categories'])"
                  icon="far fa-cubes"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="دسته بندی ها"
                  :submenus="[
                      {id:1, title:'لیست دسته بندی ها', route:{name:'Category'}, perm:'categories'},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['users'])"
                  icon="far fa-users"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="کاربران"
                  :submenus="[
                      {id:1, title:'لیست کاربران', route:{name:'User'}, perm:'users'},
                  ]"
              />
             
              <DashboardAside
                  icon="far fa-link"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="نقش  و دسترسی ها"
                  :submenus="[
                      {id:1, title:'لیست نقش ها', route:{name:'Role'}},
                      {id:2, title:'لیست دسترسی ها', route:{name:'Permission'}}
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['courses','coursecompleteds','financialdocuments','installment_plans','courserequests'])"
                  icon="far fa-book-open"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="دوره ها"
                  :submenus="[
                      {id:1, title:'لیست دوره ها', route:{name:'Course'}, 'perm':'courses'},
                      {id:2, title:'قسط بندی دوره ها', route:{name:'InstallmentPlan'}, 'perm':'installment_plans'},
                      {id:3, title:'لیست درخواست های ثبت نام در دوره', route:{name:'CourseRequest'}, 'perm':'courserequests'},
                      {id:4, title:'دوره های پایان یافته', route:{name:'CourseCompleted'}, 'perm':'coursecompleteds'},
                      {id:5, title:'لیست سند مالی', route:{name:'FinancialDocument'}, 'perm':'financialdocuments'},

                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['events','orders','transactions','eventcompleteds','gift_packages','manager_requests'])"
                  icon="far fa-presentation"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="همایش و سمینار ها"
                  :submenus="[
                      {id:1, title:'لیست همایش و سمینار ها', route:{name:'Event'}, 'perm':'events'},
                      {id:2, title:'لیست هدایا', route:{name:'GiftPackage'}, 'perm':'gift_packages'},
                      {id:3, title:'لیست شرکت کنندگان', route:{name:'Order'}, 'perm':'orders'},
                      {id:4, title:'لیست تراکنش ها', route:{name:'Transaction'}, 'perm':'transactions'},
                      {id:5, title:'همایش و سمینار های پایان یافته', route:{name:'EventCompleted'}, 'perm':'eventcompleteds'},
                      {id:6, title:' درخواست مدیریت همایش و سمینار ', route:{name:'ManagerRequest'}, 'perm':'manager_requests'},

                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['ticketcategories','tickets'])"
                  icon="far fa-messages"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="تیکت ها"
                  :submenus="[
                      {id:1, title:'لیست موضوعات تیکت ها', route:{name:'TicketCategory'}, perm:'ticketcategories'},
                      {id:2, title:'لیست تیکت ها', route:{name:'Ticket'}, perm:'tickets'},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['smsmessages'])"
                  icon="far fa-message-sms"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="پیامک ها"
                  :submenus="[
                      {id:1, title:'لیست پیامک ها', route:{name:'SmsMessage'}, perm:'smsmessages'},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['entrycards','certificatetemplates','templatefonts'])"
                  icon="far fa-address-card"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="قالب کارت ها"
                  :submenus="[
                      {id:1, title:'لیست قالب کارت ها', route:{name:'EntryCard'}, perm:'entrycards'},
                      {id:2, title:'لیست قالب گواهینامه ها', route:{name:'CertificateTemplate'}, perm:'certificatetemplates'},
                      {id:3, title:'لیست فونت ها', route:{name:'TemplateFont'}, perm:'templatefonts'},
                  ]"
              />

              <DashboardAside
                  v-if="hasPermission(['cards'])"
                  icon="far fa-address-card"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="کارت ها"
                  :submenus="[
                      {id:1, title:'لیست کارت دوره ها', route:{name:'MyCourseCard'}, perm:'cards'},
                      {id:2, title:'لیست کارت رویدادها', route:{name:'MyEventCard'}, perm:'cards'},
                  ]"
              />

              <DashboardAside
                  v-if="hasPermission(['cards','certificates'])"
                  icon="far fa-address-card"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="گواهینامه ها"
                  :submenus="[
                      {id:1, title:'لیست گواهینامه دوره ها', route:{name:'MyCourseCertificate'}, perm:'certificates'},
                      {id:2, title:'لیست گواهینامه رویدادها', route:{name:'MyEventCertificate'}, perm:'certificates'},

                  ]"
              />


              <DashboardAside
                  v-if="hasPermission(['news'])"
                  icon="far fa-newspaper"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="مقالات"
                  :submenus="[
                      {id:1, title:'لیست مقالات', route:{name:'Article'}, perm:'news'},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['comments'])"
                  icon="far fa-message"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="دیدگاه ها"
                  :submenus="[
                      {id:1, title:'لیست دیدگاه ها', route:{name:'Comment'}, perm:'comments'},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['sliders','contactuses','siteconfigs'])"
                  icon="far fa-cogs"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="تنظیمات"
                  :submenus="[
                      {id:1, title:'لیست تنظیمات سایت', route:{name:'SiteConfig'}, perm:'siteconfigs'},
                      {id:2, title:'لیست اسلایدر', route:{name:'Slider'}, perm:'sliders'},
                      {id:3, title:'لیست تماس با ما', route:{name:'ContactUs'}, perm:'contactuses'},
                  ]"
              />
              <DashboardAside
                  v-if="hasPermission(['discounts'])"
                  icon="far fa-percentage"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="تخفیف ها"
                  :submenus="[
                      {id:1, title:'لیست تخفیف ها', route:{name:'Discount'}, perm:'discounts'},
                  ]"
              />
            </ul>

            <ul class="flex flex-col" v-if="$store.state.user.access === 'event_manager'">
              <DashboardAside
                  icon="far fa-book-open"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="دوره ها"
                  :submenus="[
                      {id:1, title:'لیست دوره ها', route:{name:'Course'}},
                      {id:2, title:'قسط بندی دوره ها', route:{name:'InstallmentPlan'}},
                      {id:3, title:'لیست درخواست های ثبت نام در دوره', route:{name:'CourseRequest'}},
                      {id:4, title:'دوره های پایان یافته', route:{name:'CourseCompleted'}},
                      {id:5, title:'لیست سند مالی', route:{name:'FinancialDocument'}},

                  ]"
              />
              <DashboardAside
                  icon="far fa-presentation"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="همایش و سمینار ها"
                  :submenus="[
                      {id:1, title:'لیست همایش و سمینار ها', route:{name:'Event'}},
                      {id:2, title:'لیست شرکت کنندگان', route:{name:'Order'}},
                      {id:3, title:'لیست تراکنش ها', route:{name:'Transaction'}},
                      {id:4, title:'همایش و سمینار های پایان یافته', route:{name:'EventCompleted'}},
                      {id:5, title:'خدمات', route:{name:'EventService'}},
                      {id:6, title:'درخواست مدیریت همایش و سمینار ', route:{name:'ManagerRequest'}},

                  ]"
              />

              
              <DashboardAside
                  icon="far fa-address-card"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="کارت ها"
                  :submenus="[
                      {id:1, title:'لیست کارت دوره های من', route:{name:'MyCourseCard'}},
                      {id:2, title:'لیست کارت رویدادهای من', route:{name:'MyEventCard'}},
                      {id:3, title:'لیست کارت دوره های تحت مدیریت من', route:{name:'MyStudentCourseCard'} },
                      {id:4, title:'لیست کارت رویدادهای تحت مدیریت من', route:{name:'MyStudentEventCard'}},
                  ]"
              />

              <DashboardAside
                  icon="far fa-address-card"
                  :tab="Math.floor(Math.random()*10000)"
                  menu=" گواهینامه ها"
                  :submenus="[
                      {id:1, title:'لیست گواهینامه دوره های من', route:{name:'MyCourseCertificate'}},
                      {id:2, title:'لیست گواهینامه رویدادهای من', route:{name:'MyEventCertificate'}},
                      {id:3, title:'لیست گواهینامه دوره های تحت مدیریت من', route:{name:'MyStudentCourseCertificate'}},
                      {id:4, title:'لیست گواهینامه رویدادهای تحت مدیریت من', route:{name:'MyStudentEventCertificate'}},
                  ]"
              />

              <DashboardAside
                  icon="far fa-address-card"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="قالب کارت ها"
                  :submenus="[
                      {id:1, title:'لیست قالب کارت ها', route:{name:'EntryCard'}},
                      {id:2, title:'لیست قالب گواهینامه ها', route:{name:'CertificateTemplate'}},
                      {id:3, title:'لیست فونت ها', route:{name:'TemplateFont'}},
                  ]"
              />

              <DashboardAside
                  icon="far fa-message"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="دیدگاه ها"
                  :submenus="[
                      {id:1, title:'لیست دیدگاه ها', route:{name:'Comment'}},
                  ]"
              />

              <DashboardAside
                  icon="far fa-message"
                  :tab="Math.floor(Math.random()*10000)"
                  menu=" پنل پیامک"
                  :submenus="[
                      {id:1, title:'شارژ پنل پیامک', route:{name:'SmsPanelCharge'}},
                      {id:2, title:'لیست پیامک ها', route:{name:'SmsMessage'}},
                  ]"
              />
            </ul>

            <ul class="flex flex-col" v-if="$store.state.user.access === 'user'">
              <DashboardAside
                  icon="far fa-book-open"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="دوره ها"
                  :submenus="[
                      {id:1, title:'لیست درخواست های ثبت نام در دوره', route:{name:'CourseRequest'}},
                      {id:1, title:'دوره های پایان یافته', route:{name:'CourseCompleted'}},
                      {id:2, title:'لیست سند مالی', route:{name:'FinancialDocument'}},
                  ]"
              />
              <DashboardAside
                  icon="far fa-presentation"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="همایش و سمینار ها"
                  :submenus="[
                      {id:1, title:'لیست همایش ها', route:{name:'Order'}},
                      {id:2, title:'همایش و سمینار های پایان یافته', route:{name:'EventCompleted'}},
                      {id:3, title:'لیست تراکنش ها', route:{name:'Transaction'}},
                      {id:4, title:'درخواست مدیریت همایش و سمینار ', route:{name:'ManagerRequest'}},

                  ]"
              />
              <DashboardAside
                  icon="far fa-messages"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="تیکت ها"
                  :submenus="[
                      {id:1, title:'لیست تیکت ها', route:{name:'Ticket'}},
                  ]"
              />
              <DashboardAside
                  icon="far fa-address-card"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="کارت ها"
                  :submenus="[
                      {id:1, title:'لیست کارت دوره ها', route:{name:'MyCourseCard'}},
                      {id:2, title:'لیست کارت رویدادها', route:{name:'MyEventCard'}},
                  ]"
              />

              <DashboardAside
                  icon="far fa-address-card"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="گواهینامه ها "
                  :submenus="[
                    {id:1, title:'لیست گواهینامه دوره ها', route:{name:'MyCourseCertificate'}},
                    {id:2, title:'لیست گواهینامه رویدادها', route:{name:'MyEventCertificate'}},                  
                  ]"
              />
            </ul>
            <ul class="flex flex-col">

              <DashboardAside
                  icon="far fa-user-check"
                  :tab="Math.floor(Math.random()*10000)"
                  menu="پروفایل"
                  :submenus="[
                      {id:1, title:'پروفایل', route:{name:'Profile'}},
                      {id:2, title:'تغییر رمز عبور', route:{name:'ChangePassword'}},
                  ]"
              />
            </ul>
          </div>
        </aside>
        <div :class="['flex flex-col fm:w-full fd:w-[77%]']">
          <header class="border-b border-gray-300 px-4 py-2 bg-white">
            <div class="flex items-center justify-between fd:justify-end">
              <div class="fd:hidden">
                <span class="cursor-pointer" @click="$store.state.toggleAside = !$store.state.toggleAside"><font-awesome-icon icon="fa-bars fa-bars" class="icon text-xl fm:text-sm"/></span>
              </div>
              <div class="flex items-center gap-10">
                <div class="relative group">
                  <span class="text-blue-600"><font-awesome-icon icon="fa-bars fa-bell" class="icon"/></span>
                  <div v-if="hasNotifications" class="absolute top-4 left-2">
                    <div class="w-2 h-2 bg-red-500 rounded-full animate-ping"></div>
                  </div>
                  <div class="group-hover:block hidden bg-white shadow absolute top-4 w-[16rem] left-0 rounded">
                    <ul>
                      <li class="hover:bg-gray-200 text-gray-600 fm:text-sm border p-2 border-gray-200" v-for="item in checkDueDateNotifications" :key="item.id">
                        <routerLink :to="{name:'FinancialDocument', query:{search:jsonParse(item.data).check_due_date.number}}" class="hover:text-red-500 flex flex-col gap-1">
                          <span class="text-sm !font-medium">سررسید چک سند مالی</span>
                          <span class="text-sm"> سند: {{jsonParse(item.data).check_due_date.number}}</span>
                        </routerLink>
                      </li>
                      <li class="hover:bg-gray-200 text-gray-600 fm:text-sm border p-2 border-blue-200" v-for="item in contactUsNotifications" :key="item.id">
                        <routerLink :to="{name:'ContactUs', query:{search:jsonParse(item.data).contact_us.subject}}" class="hover:text-red-500 flex flex-col gap-1">
                          <span class="text-sm !font-medium">تماس با ما</span>
                          <span class="text-sm"> موضوع: {{jsonParse(item.data).contact_us.subject}}</span>
                        </routerLink>
                      </li>
                      <li class="hover:bg-gray-200 text-gray-600 fm:text-sm border p-2 border-blue-200" v-for="item in managerRequestsNotifications" :key="item.id">
                        <routerLink :to="{name:'ManagerRequest'}" class="hover:text-red-500 flex flex-col gap-1">
                          <span class="text-sm">یک درخواست جدید برای مدیریت همایش و سمینار ثبت شد</span>
                        </routerLink>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class=" cursor-pointer group relative">
                  <div>
                    <img :src="$store.state.url + $store.state.user.avatar" class="rounded-full w-[40px] h-[40px]"/>
                  </div>
                  <div class="group-hover:block hidden bg-white shadow absolute top-[3rem] w-[12rem] left-0 rounded">
                    <ul>
                      <li class="bg-gray-100 p-2 hover:bg-gray-200 text-gray-600 fm:text-sm" @click="logout()">خروج</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <main class="p-4">
            <router-view></router-view>
          </main>

        </div>
      </div>
    </div>
    <Modal title="هشدار" save="رفتن به پروفایل" @callback="openProfile" ref="openAlertModal">
      <div class="flex flex-col gap-2">
        <p class="text-lg text-red-400 !font-medium">
          با توجه به اینکه تمامی فرایندهای دریافت کارت، پکیج و گواهینامه، الکترونیکی است برای دریافت کامل خدمات  رویداد، لطفا پروفایل خود را تکمیل نمایید.
        </p>
      </div>
    </Modal>
  </div>
</template>

<script>
export default{name: "DashboardLayout"}
</script>

<script setup>
import {ref ,onMounted} from "vue";
import axios from "@/plugins/axios";
import DashboardAside from "@/components/DashboardAside";
import Modal from "@/components/Modal";
import store from "@/store";
import { useRouter } from "vue-router";

const router = useRouter();
let checkDueDateNotifications = ref([])
let contactUsNotifications = ref([])
let managerRequestsNotifications = ref([])
let hasNotifications = ref(false);
let walletAmount =ref(0);
let isAdmin = ref(store.state.user.access === 'admin')
let isEventManager = ref(store.state.user.access === 'event_manager')
let openAlertModal = ref(null)
onMounted(async ()=>{
  if(!isAdmin.value && !store.state.user.has_profile){
    openAlertModal.value.toggleModal();
  }
  await index()
})

async function index(){
  await axios.get(`${store.state.api}dashboard-index`).then(resp=>{
    let data = resp.data.data;
    walletAmount.value = data.wallet_amount;
    checkDueDateNotifications.value = data.check_due_date_notifies;
    contactUsNotifications.value = data.contact_us_notification;
    managerRequestsNotifications.value = data.manager_requests_notifications;
    hasNotifications.value = data.has_notifications;
    if(data.store_detail){
      store.state.siteName = data.store_detail.site_name_ir
      store.state.url = data.store_detail.site_url ? data.store_detail.site_url : process.env.VUE_APP_BACKEND;
      store.state.api = data.store_detail.site_url ? data.store_detail.site_url : process.env.VUE_APP_BACKEND;
      store.state.api += '/api/';
      store.dispatch('setFavicon',data.store_detail.favicon)
      store.state.configSite = {...data.store_detail}
    }
    if(data.social_media){
      store.state.configSite.social_media = {...data.social_media};
    }
  })
}

async function logout(){
  await axios.post(`${store.state.api}logout`).then(resp=>{
    store.commit('clearStorage')
    router.push({name:'Index'})
  })
}


function hasPermission(_permissions){
  let existPerms = [];
  for(let i = 0; i < _permissions.length; i++){
    for(let j = 0; j < store.state.userPermissions.length; j++){
      if(store.state.userPermissions[j].search(_permissions[i]) > 0){
        existPerms.push(true);
      }
    }
  }
  return existPerms.filter(item=>item).length > 0;
}

function jsonParse(data){
  return JSON.parse(data)
}

function openProfile(){
  router.push({name:'Profile'})
  openAlertModal.value.toggleModal();
}
</script>